import { useEffect, useState } from "react";
import { collection, orderBy, query, where, doc } from "firebase/firestore";
import { useCollection } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { mapAddress } from "../util/mapAddress";

export const useSailorAddresses = ({ sailorId }) => {
  const [sailorAddresses, setSailorAddresses] = useState([]);
  const [value, loading, error] = useCollection(
    query(
      collection(db, "sailorAddresses"),
      where("sailor", "==", doc(db, "sailors", sailorId)),
      //todo: by adding the orderBy documents without a from date disappear - ideally sort locally
      orderBy("from", "desc")
    )
  );
  useEffect(() => {
    if (value) {
      const docs = value.docs.map((doc) => mapAddress(doc));
      setSailorAddresses(docs);
    }
  }, [value, sailorId]);

  return { sailorAddresses, loading, error };
};
